import { Pipe, PipeTransform } from '@angular/core';
import { DimensionUnitEnum } from '../../../enum/dimension-unit.enum';
import { Dimensions } from '../../../utils/dimensions';

@Pipe({
    name: 'dimension',
    standalone: true
})
export class DimensionPipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): unknown {
        return Dimensions.render(value, args[0] as DimensionUnitEnum);
    }

}
